import { configureStore } from "@reduxjs/toolkit";

// Front
import LayoutReducer from "./slices/layouts/reducer";

// Authentication
import LoginReducer from "./slices/auth/login/reducer";
import AccountReducer from "./slices/auth/register/reducer";
import ProfileReducer from "./slices/auth/profile/reducer";

// API Key
import commonReducer from "./slices/common/reducer";
import moduleAccessSlice from "./slices/moduleAccess/moduleAccessSlice";
import findDataSlice from "./slices/moduleAccess/findDataSlice";
import checkedDataSlice from "./slices/moduleAccess/checkedDataSlice";
import moduleAccessTree from "./slices/moduleAccess/moduleAccessTree";
import serviceProviderReducer from "./slices/psp/serviceProvider/reducer";
import affinityGroupSlice from "./slices/ag/affinityGroup/affinityGroupSlice";
import sidebarSlice from "./slices/sidebar/sidebarSlice";
import usersSlice from "./slices/team/users/usersSlice";
import rolesSlice from "./slices/team/roles/rolesSlice";
import headerSlice from "./slices/header/headerSlice";
import agMemberSlice from "./slices/agMember/agMemberSlice";
import productSlice from "./slices/product/productSlice";
import informationSlice from "./slices/hub/informationSlice";
import organizationSlice from "./slices/org/organizationSlice";
import organizationRelationshipSlice from "./slices/org/organizationRelationshipSlice";
import oemSlice from "./slices/oem/oemSlice";
import orderSlice from "./slices/orders/orderSlice";
import ipSettingsSlice from "./slices/IpSettings/ipSettingsSlice";
import reportsSlice from "./slices/reports/reportsSlice";
import qualificationSlice from "./slices/qualification/qualificationsSlice";
import bulkOrderSlice from "./slices/bulkOrder/bulkOrderSlice";

export const rootReducer = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    header: headerSlice,
    sidebar: sidebarSlice,
    moduleaccesstree: moduleAccessTree,
    moduleAccess: moduleAccessSlice,
    checkedData: checkedDataSlice,
    findData: findDataSlice,
    common: commonReducer,
    users: usersSlice,
    roles: rolesSlice,
    serviceProvider: serviceProviderReducer,
    affinityGroup: affinityGroupSlice,
    agMember: agMemberSlice,
    oem: oemSlice,
    product: productSlice,
    information: informationSlice,
    organization: organizationSlice,
    organizationRelationship: organizationRelationshipSlice,
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    order: orderSlice,
    ipSettings: ipSettingsSlice,
    reports: reportsSlice,
    qualification: qualificationSlice,
    bulkOrder: bulkOrderSlice,
  },
  devTools: true,
});
export default rootReducer;
